export default (state) => state.userRoles.data
